import React, { useEffect, useState } from "react";
import { Chart } from 'react-google-charts';
import { useTranslation } from "react-i18next";

import '../testReport.css';
import QuestionChart from "./QuestionChart";

import { FaLongArrowAltDown } from "react-icons/fa";

function createAxis(max_num) {
    return Array.from({ length: max_num + 2 }, (_, index) => index - 1);
}

const QuestionwiseStatistics = ({ data = null, num_questions = null, num_students = null }) => {

    const [chartHeight, setChartHeight] = useState(200); // Default height
    const [isChartView, setChartview] = useState(true);
    const [sortCriterion, setSortCriterion] = useState("Correct");

    const questionIds = Object.keys(data);
    const values = Object.values(data);

    const { t } = useTranslation();
    const chartData = [
        ["Question ID", "Number (ID)", "Correct", "Incorrect", "Partially Correct", "No Response",],

        ...questionIds.map((questionId, index) => [
            questionId,
            `Q${index + 1} (${questionId})`,
            // questionId,
            // questionIds.indexOf(questionId),
            values[index].correct_by_number_of_students,
            values[index].incorrect_by_number_of_students,
            values[index].partial_correct_by_number_of_students,
            values[index].no_response_by_number_of_students,

        ]),
    ];

    const sortData = (data, criterion) => {
        return data.slice(1).sort((a, b) => {
            if (criterion === 'Correct') {
                return b[2] - a[2]; // Sort by correct responses
            } else if (criterion === 'Incorrect') {
                return b[3] - a[3]; // Sort by incorrect responses
            } else if (criterion === 'Noresponse') {
                return b[5] - a[5]; // Sort by incorrect responses
            } else {
                return 0; // No sorting
            }
        });
    };

    const sortedChartData = [
        chartData[0],
        ...sortData(chartData, sortCriterion),
    ];

    const hAxis = createAxis(num_students);

    const questionData = sortedChartData.slice(1);

    // Calculate the desired chart height based on data
    useEffect(() => {
        const numberOfDataPoints = chartData.length; // Adjust this based on your data
        const minHeight = 300; // Minimum height for the chart
        const calculatedHeight = Math.max(minHeight, numberOfDataPoints * 15); // Adjust the multiplier as needed

        setChartHeight(calculatedHeight);
    }, [chartData]);

    return (
        <div className="statistics-section flex">
            <div className="statistics-buttons">
                <div className="statistics-sort-buttons">
                    <button className={`statistics-button ${sortCriterion === "Correct" ? "active" : ""}`}
                        onClick={() => setSortCriterion("Correct")}>
                        {t('correct')} <FaLongArrowAltDown />
                    </button>
                    <button className={`statistics-button ${sortCriterion === "Incorrect" ? "active" : ""}`}
                        onClick={() => setSortCriterion("Incorrect")}>
                        {t('incorrect')} <FaLongArrowAltDown />
                    </button>
                    <button className={`statistics-button ${sortCriterion === "Noresponse" ? "active" : ""}`}
                        onClick={() => setSortCriterion("Noresponse")}>
                        {t('noResponse')} <FaLongArrowAltDown />
                    </button>
                </div>

                <div className="statistics-view-buttons">
                    <button className={`statistics-button ${isChartView ? 'active' : ''}`} onClick={() => setChartview(true)}>{t('chart')}</button>
                    <button className={`statistics-button ${isChartView ? '' : 'active'}`} onClick={() => setChartview(false)}>{t('table')}</button>
                </div>
            </div>

            {isChartView ? (
                <>
                    <div className="question-wise-charts-legends">
                        <div className="question-wise-charts-legend"> <div className="circle-legend" id="correct"></div><p className="legend-text">Correct</p></div>
                        <div className="question-wise-charts-legend"> <div className="circle-legend" id="incorrect"></div><p className="legend-text">Incorrect</p></div>
                        <div className="question-wise-charts-legend"> <div className="circle-legend" id="partial-correct"></div><p className="legend-text">Partially Correct</p></div>
                        <div className="question-wise-charts-legend"> <div className="circle-legend" id="no-response"></div><p className="legend-text">No Response</p></div>
                    </div>
                    <div className="question-wise-charts">
                        {questionData.map((data, index) => (
                            <div key={data[0]} className="question-chart">
                                <QuestionChart inputData={data} dataType={"question"} />
                            </div>
                        ))}
                    </div>
                </>

            ) : (
                <div className="question-wise-table">

                    <table className="report-table">

                        <thead>
                            <tr>
                                <th>{t('numberID')}</th>
                                <th>{t('correct')}</th>
                                <th>{t('incorrect')}</th>
                                <th>{t('partialCorrect')}</th>
                                <th>{t('noResponse')}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {questionData.map((questionEntry, index) => (
                                <tr key={index}>
                                    <td>{questionEntry[1]}</td>
                                    <td>{questionEntry[2]}</td>
                                    <td>{questionEntry[3]}</td>
                                    <td>{questionEntry[4]}</td>
                                    <td>{questionEntry[5]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

        </div>
    );
};

export default QuestionwiseStatistics;